// extracted by mini-css-extract-plugin
export default {"register-form":"ForgotPasswordForm_register-form__YYy22","input-style":"ForgotPasswordForm_input-style__uZna8","btn-style":"ForgotPasswordForm_btn-style__Ryx0F"};